/* eslint-disable sort-keys */
export const COURSE_TREE_LEAF_BUTTON_TYPE = {
  TEACHER_BUTTON_PDF_AND_FLOWPAPER: 'TEACHER_BUTTON_PDF_AND_FLOWPAPER',
  TEACHER_BUTTON_VIEW: 'TEACHER_BUTTON_VIEW',
  DOWNLOAD_BUTTON: 'DOWNLOAD_BUTTON',
  TEACHER_BUTTON_LINK_TO_COURSE: 'TEACHER_BUTTON_LINK_TO_COURSE',
  TEACHER_BUTTON_ASSIGN: 'TEACHER_BUTTON_ASSIGN',
  TEACHER_BUTTON_PRESENT: 'TEACHER_BUTTON_PRESENT',
  TEACHER_BUTTON_REMOVE: 'TEACHER_BUTTON_REMOVE'
};

export const COURSE_TREE_LEAF_DEFAULT_BUTTON_TYPE_ORDER_ARRAY = [
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_PDF_AND_FLOWPAPER,
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_VIEW,
  COURSE_TREE_LEAF_BUTTON_TYPE.DOWNLOAD_BUTTON,
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_LINK_TO_COURSE,
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_ASSIGN,
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_PRESENT,
  COURSE_TREE_LEAF_BUTTON_TYPE.TEACHER_BUTTON_REMOVE
];
